import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuthItem } from '@/utils/authStorage'
import HomeView from '../views/HomeView.vue'
import AcceptInvitationView from '../views/authentication/AcceptInvitationPage.vue'
import EmailVerificationView from '../views/authentication/EmailVerificationPage.vue'
import LoginView from '../views/authentication/LoginPage.vue'
import ForgotPasswordView from '../views/authentication/ForgotPasswordPage.vue'
import ResetPasswordView from '../views/authentication/ResetPasswordPage.vue'
import ResetSuccess from '../views/authentication/ResetPasswordSuccess.vue'
import ResetFailed from '../views/authentication/ResetPasswordFailed.vue'
import DashboardView from '../views/DashboardView.vue'
import DevicesView from '../views/DevicesView.vue'
import MeasurementsView from '../views/MeasurementsView.vue'
import GlucoseReadingsView from '../views/GlucoseReadingsView.vue'
import UsersView from '../views/UsersView.vue'
import AccountsView from '../views/AccountsView.vue'
import ProfileView from '@/views/ProfileView.vue'

// import  component  from 'vue/types/umd'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeView,
    redirect: '/dashboard', // Redirect to a default child route like '/dashboard'
    meta: { requiresAuth: true }, // Protected route
    children:[
      { path: 'dashboard',        component: DashboardView,        meta: { title: 'Dashboard' } },
      { path: 'devices',          component: DevicesView,          meta: { title: 'Devices' } },
      { path: 'measurements',     component: MeasurementsView,     meta: { title: 'Measurements' } },
      { path: 'glucose-readings', component: GlucoseReadingsView,  meta: { title: 'Glucose Readings' } },
      { path: 'users',            component: UsersView,            meta: { title: 'App Users' } },
      { path: 'accounts',         component: AccountsView,         meta: { title: 'Accounts' } },
      { path: 'profile',          component: ProfileView,          meta: { title: 'Profile' } },
    ]
  },
  {
    path: '/accept-invitation/:token',
    name: 'acceptinvitation',
    component: AcceptInvitationView,
    meta: { title: 'Accept Invitation' },
  },
  {
    path: '/emailverify',
    name: 'emailverify',
    component: EmailVerificationView,
    meta: { title: 'Verify Email' },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { title: 'Sign in' },
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    component: ForgotPasswordView,
    meta: { title: 'Forgot Password' },
  },
  {
    path: '/resetpassword/:token',
    name: 'resetpassword',
    component: ResetPasswordView,
    meta: { title: 'Reset Password' },
  },
  {
    path: '/resetsuccess',
    name: 'resetsuccess',
    component: ResetSuccess,
    meta: { title: 'Password Reset' },
  },
  {
    path: '/resetfailed',
    name: 'resetfailed',
    component: ResetFailed,
    meta: { title: 'Password Reset' },
  },
]

const router = new VueRouter({
  routes
})

// Add a global navigation guard
router.beforeEach((to, from, next) => {
  // Resolves against sessionStorage or localStorage — see utils/authStorage.
  const isAuthenticated = !!getAuthItem('authToken');
  const userRole = parseInt(getAuthItem('userRole'), 10) || 0;

  // Routes that should only be available to unauthenticated users
  const unauthenticatedRoutes = ['login', 'acceptinvitation', 'forgotpassword', 'resetpassword', 'resetsuccess', 'resetfailed','emailverify'];

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // If the route requires authentication and the user is not authenticated
    if (!isAuthenticated) {
      next({ name: 'login' });
    } else if (to.path === '/accounts' && userRole !== 1) {
      next({ path: '/dashboard' }); // Redirect if user is not an admin
    } else {
      next();
    }
  } else if (isAuthenticated && unauthenticatedRoutes.includes(to.name)) {
    // If the user is authenticated and trying to access an unauthenticated route, redirect them
    next({ path: '/' });
  } else {
    next();
  }
});

// Keep the document.title in sync with the route. The meta.title is read
// from the most-specific matched record (children win over their parent).
const BASE_TITLE = 'PreEvnt AP';
router.afterEach((to) => {
  const titled = [...to.matched].reverse().find((r) => r.meta && r.meta.title);
  document.title = titled ? `${BASE_TITLE} - ${titled.meta.title}` : BASE_TITLE;
});

export default router
